import { type TaskAddInput, type TaskAddSuccess, type TaskData } from '@terros/common'
import { mutationAdd, type AddHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useTaskCache } from './cache'

export const useAddTask = (): AddHookResponse<TaskAddInput, TaskData[]> => {
  const mutation = useTantalimMutation<TaskAddInput, TaskAddSuccess>({
    url: '/task/add',
  })
  const cache = useTaskCache()

  async function add(task: TaskAddInput): Promise<TaskData[]> {
    try {
      const response = await mutation.mutateAsync(task)
      cache.clearList()
      return response.tasks
    } catch (error) {
      throw error
    }
  }

  return mutationAdd(mutation, add)
}
